import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'insider-m8_settings_page_billing_history-click';
/**
 * Insider International settings page billing history link click event
 */ export function trackInsiderM8SettingsPageBillingHistoryClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
